import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { Button } from 'components/Form/Button/Button';

import { useUnsavedChangesModal } from './useUnsavedChangesModal';

type UnsavedChangesModalProps = {
  shouldBlock: boolean;
};

export const UnsavedChangesModal: FC<UnsavedChangesModalProps> = ({ shouldBlock }) => {
  const { t } = useTranslation();
  const { modalProps } = useUnsavedChangesModal(shouldBlock);

  return (
    <BasePopup open={modalProps.open} setOpen={modalProps.onCancel}>
      <BasePopup.Body>
        <h1 className="text-lg font-semibold text-gray-900">{t('webedi:unsavedChanges.confirmationModal.title')}</h1>
        <p className="mt-2 text-sm text-gray-500">{t('webedi:unsavedChanges.confirmationModal.description')}</p>
        <div className="mt-4 flex items-center justify-end gap-2">
          <Button variant="secondary" onClick={modalProps.onCancel} analyticsId="cancel-unsaved-changes-navigation">
            {t('common:cancel')}
          </Button>
          <Button variant="primary" onClick={modalProps.onConfirm} analyticsId="confirm-unsaved-changes-navigation">
            {t('webedi:unsavedChanges.confirmationModal.confirm')}
          </Button>
        </div>
      </BasePopup.Body>
    </BasePopup>
  );
};
